export const channelListPath = "/channels";
export const channelPath = "/channels/[channelId]";
export const paymentProviderListPath = "/payment-providers";
export const paymentProviderPath = "/payment-providers/[paymentProviderId]";
export const customizationPath = "/customization";
